module.exports = __webpack_public_path__ + "img/애고미_이모티콘-11.f122edc.png";